<app-header></app-header>
<div class="main-container d-flex">
  <app-sidebar></app-sidebar>
  <div class="h-100p overflow-y-scroll w-100">
    <div class="custom_container">
      <div class="search-container">
        <!-- Top bar -->
        <div class="dossier-topbar">
          <div class="dossier-topbar-left">
            <button type="button" class="back-button" (click)="onBackButtonClick()">
              <i class="fas fa-arrow-left" aria-hidden="true"></i>
              Back
            </button>
          </div>

          <div class="dossier-topbar-center" *ngIf="selectedSearchResult?.searched_phone">
            <h1 class="topbar-phone">{{ selectedSearchResult?.searched_phone }}</h1>
          </div>

          <div class="dossier-topbar-right" *ngIf="selectedSearchResult">
            <div class="search-box">
              <i class="fas fa-search search-box-icon" aria-hidden="true"></i>
              <input
                class="search-input"
                type="text"
                placeholder="Filter findings…"
                [(ngModel)]="searchTerm"
                (ngModelChange)="onSearchTermChange()"
              />
            </div>

            <button
              type="button"
              class="google-jump-button"
              *ngIf="showGoogleResults"
              (click)="jumpToGoogleResults()"
              aria-label="Jump to Google Results"
            >
              <i class="fas fa-search" aria-hidden="true"></i>
              Google Results
            </button>

            <!-- Export temporarily disabled
            <div class="dropdown">
              <button
                class="export-button dropdown-toggle"
                type="button"
                id="exportDropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="fas fa-download" aria-hidden="true"></i>
                Export
              </button>
              <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="exportDropdown">
                <li>
                  <a class="dropdown-item export-item" (click)="onExportOptionClick('pdf')">Export as PDF</a>
                </li>
                <li>
                  <a class="dropdown-item export-item" (click)="onExportOptionClick('docx')">Export as DOCX</a>
                </li>
              </ul>
            </div>
            -->
          </div>
        </div>

        <!-- Loader -->
        <div *ngIf="isLoadingResults" class="loading-container text-center my-3">
          <div class="spinner-border" role="status"></div>
          <p class="mt-2 loading-text">Fetching results, please wait…</p>
        </div>

        <!-- Split: images 40% left, identity + sources 60% right -->
        <div
          class="dossier-split"
          *ngIf="!isLoadingResults && selectedSearchResult && (searchResultImages?.length || loadingImages || identityRows.length || searchResultDetailsFiltered?.length)"
        >
          <section class="dossier-card visual-evidence" aria-label="Visual evidence">
            <header class="dossier-card-header">
              <span class="dossier-card-title">
                <i class="fas fa-images" aria-hidden="true"></i>
                Visual Evidence
              </span>
              <span class="dossier-card-count" *ngIf="!loadingImages">{{ searchResultImages.length }}</span>
            </header>
            <div class="dossier-card-body">
              <div *ngIf="loadingImages" class="image-loader-container text-center">
                <div class="spinner-border" role="status"></div>
                <p class="mt-2 loading-text">Loading images…</p>
              </div>
              <div
                class="evidence-grid"
                *ngIf="!loadingImages && searchResultImages.length"
                [class.is-single]="searchResultImages.length === 1"
              >
                <button
                  type="button"
                  class="evidence-item"
                  *ngFor="let searchResultImage of searchResultImages; let i = index"
                  (click)="openLightbox(i)"
                  [attr.aria-label]="'Open image ' + (searchResultImage.name || i + 1)"
                >
                  <img
                    [src]="getEvidenceImageSrc(searchResultImage)"
                    [alt]="searchResultImage.name || 'Evidence photo'"
                    [class.is-placeholder]="!searchResultImage.src"
                    (error)="onEvidenceImageError($event)"
                  />
                  <span class="evidence-caption" *ngIf="searchResultImage.platform || searchResultImage.name">
                    {{ searchResultImage.platform || searchResultImage.name }}
                  </span>
                </button>
              </div>
              <div class="evidence-empty" *ngIf="!loadingImages && !searchResultImages.length">
                <div class="evidence-item is-empty" aria-hidden="true">
                  <img [src]="getEvidenceImageSrc(null)" alt="" class="is-placeholder" />
                  <span class="evidence-caption">No photo</span>
                </div>
                <p class="evidence-empty-text">No visual evidence available</p>
              </div>
            </div>
          </section>

          <div class="dossier-data-column">
            <section class="dossier-card identity-summary" *ngIf="identityRows.length" aria-label="Identity summary">
              <header class="dossier-card-header">
                <span class="dossier-card-title">
                  <i class="fas fa-id-card" aria-hidden="true"></i>
                  Identity Summary
                </span>
              </header>
              <div class="dossier-card-body">
                <div class="identity-grid">
                  <div class="identity-field" *ngFor="let row of identityRows">
                    <div class="identity-label">{{ row.label }}</div>
                    <div class="identity-values">
                      <ul class="identity-bullets" *ngIf="row.values.length > 1; else identitySingle">
                        <li *ngFor="let value of row.values">{{ value }}</li>
                      </ul>
                      <ng-template #identitySingle>
                        <span class="identity-value" *ngIf="row.values.length; else emptyIdentity">{{ row.values[0] }}</span>
                      </ng-template>
                      <ng-template #emptyIdentity>
                        <span class="identity-empty">—</span>
                      </ng-template>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section
              class="dossier-card source-findings"
              *ngIf="searchResultDetailsFiltered?.length"
              aria-label="Source findings"
            >
              <header class="dossier-card-header">
                <span class="dossier-card-title">
                  <i class="fas fa-sitemap" aria-hidden="true"></i>
                  Source Findings
                </span>
                <span class="dossier-card-count">{{ searchResultDetailsFiltered.length }} sources</span>
              </header>
              <div class="dossier-card-body">
                <div class="findings-grid">
              <article
                class="finding-card"
                *ngFor="let platform of searchResultDetailsFiltered; let platformIndex = index"
                [attr.data-status]="getPlatformStatus(platform)"
              >
                <header class="finding-header">
                  <div class="finding-identity">
                    <img
                      [src]="getPlatformIcon(platform)"
                      [alt]="platform.platform"
                      class="finding-icon"
                      [attr.data-platform]="platform.platform"
                      (error)="onIconError($event)"
                    />
                    <div class="finding-titles">
                      <h3 class="finding-name">{{ platform.platform }}</h3>
                      <p class="finding-category" *ngIf="getPlatformCategory(platform) as category">{{ category }}</p>
                    </div>
                  </div>
                  <span class="status-badge" [ngClass]="'is-' + getPlatformStatus(platform)">
                    <i [class]="getStatusIcon(platform)" aria-hidden="true"></i>
                    {{ getStatusLabel(platform) }}
                  </span>
                </header>

                <div class="finding-body" *ngIf="getPlatformStatus(platform) === 'match'">
                  <div class="result-entry" *ngFor="let entry of getVisibleEntries(platform); let entryIndex = index">
                    <div class="entry-header" *ngIf="entry.label">{{ entry.label }}</div>
                    <ul class="entry-details">
                      <li class="detail-row" *ngFor="let detail of getVisibleDetails(entry); let detailIndex = index">
                        <span class="detail-label">{{ detail.label }}</span>
                        <ng-container [ngSwitch]="detail.type">
                          <ng-container *ngSwitchCase="'link'">
                            <a [href]="utilsService.toLink(detail.value)" target="_blank" rel="noopener noreferrer">
                              {{ detail.value }}
                            </a>
                          </ng-container>
                          <ng-container *ngSwitchCase="'base64String'">
                            <div class="base64-string-container">
                              <span
                                class="detail-value base64-string"
                                [class.expanded]="isBase64Expanded(getBase64Key(platformIndex, entryIndex, detailIndex))"
                              >
                                {{
                                  isBase64Expanded(getBase64Key(platformIndex, entryIndex, detailIndex))
                                    ? detail.value
                                    : getTruncatedBase64(detail.value)
                                }}
                              </span>
                              <a
                                *ngIf="detail.value.length > 150"
                                class="show-more-link"
                                (click)="toggleBase64Expansion(getBase64Key(platformIndex, entryIndex, detailIndex))"
                              >
                                {{
                                  isBase64Expanded(getBase64Key(platformIndex, entryIndex, detailIndex))
                                    ? 'show less'
                                    : 'show more'
                                }}
                              </a>
                            </div>
                          </ng-container>
                          <ng-container *ngSwitchCase="'datetime'">
                            <span class="detail-value">{{ utilsService.formatDateTime(detail.value) }}</span>
                          </ng-container>
                          <ng-container *ngSwitchCase="'date'">
                            <span class="detail-value">{{ formatDateValue(detail.value) }}</span>
                          </ng-container>
                          <ng-container *ngSwitchCase="'boolean'">
                            <span class="detail-value">{{ detail.value ? 'Yes' : 'No' }}</span>
                          </ng-container>
                          <ng-container *ngSwitchCase="'number'">
                            <span class="detail-value">{{ detail.value }}</span>
                          </ng-container>
                          <ng-container *ngSwitchCase="'list'">
                            <span class="detail-value" *ngIf="isEmptyValue(detail.value)">N/A</span>
                            <ng-container *ngIf="!isEmptyValue(detail.value) && getDisplayListItems(detail) as listItems">
                              <div *ngIf="listItems.length <= 1" class="detail-value is-structured">
                                <app-abacus-structured-value [text]="listItems[0]"></app-abacus-structured-value>
                              </div>
                              <ul *ngIf="listItems.length > 1" class="list-value is-structured" [class.datetime-bullets]="utilsService.isDateTimeBulletList(detail)" [class.plain-bullets]="utilsService.isPlainStringList(detail)">
                                <li *ngFor="let item of listItems">
                                  <app-abacus-structured-value [text]="item"></app-abacus-structured-value>
                                </li>
                              </ul>
                            </ng-container>
                          </ng-container>
                          <ng-container *ngSwitchCase="'array'">
                            <span class="detail-value" *ngIf="isEmptyValue(detail.value)">N/A</span>
                            <ng-container *ngIf="!isEmptyValue(detail.value) && getDisplayListItems(detail) as listItems">
                              <div *ngIf="listItems.length <= 1" class="detail-value is-structured">
                                <app-abacus-structured-value [text]="listItems[0]"></app-abacus-structured-value>
                              </div>
                              <ul *ngIf="listItems.length > 1" class="list-value is-structured" [class.datetime-bullets]="utilsService.isDateTimeBulletList(detail)" [class.plain-bullets]="utilsService.isPlainStringList(detail)">
                                <li *ngFor="let item of listItems">
                                  <app-abacus-structured-value [text]="item"></app-abacus-structured-value>
                                </li>
                              </ul>
                            </ng-container>
                          </ng-container>
                          <ng-container *ngSwitchCase="'object'">
                            <span class="detail-value" *ngIf="!isEmptyValue(detail.value)">
                              {{ formatObjectValue(detail.value) }}
                            </span>
                            <span class="detail-value" *ngIf="isEmptyValue(detail.value)">{{ '{}' }}</span>
                          </ng-container>
                          <ng-container *ngSwitchCase="'dict'">
                            <div class="dict-table-container" *ngIf="!isEmptyValue(detail.value)">
                              <table class="dict-table">
                                <tbody>
                                  <tr *ngFor="let key of getObjectKeys(detail.value)">
                                    <td class="dict-key">{{ formatDictKey(key) }}</td>
                                    <td class="dict-value">{{ utilsService.formatListItemForDisplay(detail.value[key]) }}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <span class="detail-value" *ngIf="isEmptyValue(detail.value)">{{ '{}' }}</span>
                          </ng-container>
                          <ng-container *ngSwitchDefault>
                            <span class="detail-value">{{ utilsService.formatDisplayValue(detail.value) }}</span>
                          </ng-container>
                        </ng-container>
                      </li>
                    </ul>
                  </div>
                </div>

                <p class="finding-empty-msg" *ngIf="getPlatformStatus(platform) === 'no-record'">
                  No account record returned for this source.
                </p>
                <p class="finding-empty-msg is-error" *ngIf="getPlatformStatus(platform) === 'error'">
                  Source lookup failed or returned an error.
                </p>
              </article>
                </div>
              </div>
            </section>
          </div>
        </div>

        <!-- Empty / no results -->
        <div
          class="no-results-container"
          *ngIf="!isLoadingResults && selectedSearchResult && hasNoResults && !searchResultDetailsFiltered?.length"
        >
          <div class="no-results-message">
            <i class="fas fa-inbox no-results-icon" aria-hidden="true"></i>
            <h2 class="no-results-title">No findings</h2>
            <p class="no-results-text">This phone lookup did not return any source data.</p>
          </div>
        </div>

        <!-- Google Results (same CSE embed as OSINT phone search) -->
        <section
          id="google-results"
          class="dossier-card google-results-section"
          *ngIf="showGoogleResults && selectedSearchResult"
          aria-label="Google Results"
        >
          <header class="card-header-green google-header">
            <svg class="google-icon-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
            </svg>
            <span>Google Results</span>
            <a
              *ngIf="googleSearchHref"
              class="google-open-link"
              [href]="googleSearchHref"
              target="_blank"
              rel="noopener noreferrer"
            >Open in Google</a>
          </header>
          <div class="google-query-selector" *ngIf="googleQueryVariants.length > 1" role="tablist" aria-label="Google search query variants">
            <button
              type="button"
              class="google-query-chip"
              *ngFor="let variant of googleQueryVariants"
              [class.active]="selectedGoogleQueryId === variant.id"
              [attr.title]="variant.query"
              [attr.aria-selected]="selectedGoogleQueryId === variant.id"
              (click)="selectGoogleQuery(variant)"
            >
              {{ variant.label }}
            </button>
          </div>
          <div class="google-results-container">
            <iframe
              *ngIf="googleResultsUrl"
              class="google-results-iframe"
              [src]="googleResultsUrl"
              title="Google Results"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </section>

        <!-- Notes -->
        <section class="dossier-card notes-section" *ngIf="!isLoadingResults && selectedSearchResult" aria-label="Notes">
          <header class="dossier-card-header">
              <span class="dossier-card-title">
                <i class="fas fa-sticky-note" aria-hidden="true"></i>
                Investigator Notes
              </span>
          </header>
          <div class="dossier-card-body notes-content">
            <textarea
              class="note-input"
              maxlength="300"
              placeholder="Add case notes…"
              [(ngModel)]="notes"
            ></textarea>
            <div class="notes-footer">
              <span class="character-count">{{ notes.length }}/300</span>
              <button type="button" class="update-button" (click)="onUpdateNotesButtonClick()">Update Notes</button>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</div>

<!-- Image Modal -->
<div class="image-modal-overlay" *ngIf="selectedImage" (click)="closeImageModal()">
  <button
    type="button"
    class="image-modal-nav image-modal-prev"
    *ngIf="hasMultipleEvidenceImages"
    (click)="showPreviousImage($event)"
    aria-label="Previous image"
  >
    <i class="fas fa-chevron-left" aria-hidden="true"></i>
  </button>

  <div class="image-modal-content" (click)="$event.stopPropagation()">
    <button type="button" class="image-modal-close" (click)="closeImageModal()" aria-label="Close modal">
      <i class="fas fa-times" aria-hidden="true"></i>
    </button>

    <div class="image-modal-frame">
      <img
        [src]="getEvidenceImageSrc(selectedImage)"
        [alt]="selectedImage.name || 'Evidence photo'"
        class="image-modal-img"
        (error)="onEvidenceImageError($event)"
      />
    </div>

    <div class="image-modal-footer">
      <span class="image-modal-caption">
        {{ selectedImage.platform || selectedImage.name || 'Evidence' }}
      </span>
      <span class="image-modal-counter" *ngIf="searchResultImages.length">
        {{ selectedImageIndex + 1 }} / {{ searchResultImages.length }}
      </span>
    </div>
  </div>

  <button
    type="button"
    class="image-modal-nav image-modal-next"
    *ngIf="hasMultipleEvidenceImages"
    (click)="showNextImage($event)"
    aria-label="Next image"
  >
    <i class="fas fa-chevron-right" aria-hidden="true"></i>
  </button>
</div>
